module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dados-da-solicitacao",
    attrs: {
      "id": "detalhes-da-solicitacao"
    }
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "print title-print"
  }, [_vm._v("Detalhes da solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('cabecalho-da-solicitacao', {
    attrs: {
      "nome-do-titular": _vm.nomeDoTitular,
      "subsidio-da-agehab": _vm.subsidioDaAgehab,
      "acoes-da-situacao": _vm.acoesDaSituacao,
      "pode-autorizar-pagamento": _vm.podeAutorizarPagamento(),
      "pode-editar": _vm.podeEditar(),
      "pode-alterar-nup": _vm.podeAlterarNup(),
      "solicitacao-eh-do-bonus-moradia": _vm.solicitacaoEhDoBonusMoradia,
      "linha-do-tempo": _vm.solicitacao.LinhaDoTempo
    },
    on: {
      "executar-acao": _vm.executarAcaoDaSituacao,
      "abrir-pagamento": _vm.abrirModalDeConfirmacaoDePagamento,
      "editar": _vm.redirecionarParaEdicao,
      "abrir-alteracao-nup": _vm.abrirModalDeAlteracaoDeNup
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "16px",
      "margin-right": "16px"
    }
  }, [(_vm.situacaoDoPrazoDoDossie && _vm.situacaoDoPrazoDoDossie.textoDoBanner) ? _c('alerta', {
    attrs: {
      "tipo": "perigo",
      "titulo": _vm.situacaoDoPrazoDoDossie.textoDoBanner,
      "texto": _vm.situacaoDoPrazoDoDossie.descricaoDoBanner
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('abas-detalhes-solicitacao', {
    attrs: {
      "aba-selecionada": _vm.abaSelecionada,
      "total-de-itens-na-linha-do-tempo": _vm.historicoDoStatus ? _vm.historicoDoStatus.length : 0
    },
    on: {
      "update:abaSelecionada": function($event) {
        _vm.abaSelecionada = $event
      }
    }
  }), _vm._v(" "), (_vm.abaSelecionada === 'visao-geral') ? _c('div', {
    staticClass: "secao-visao-geral"
  }, [_c('protocolo-da-solicitacao', {
    attrs: {
      "existe-numero-do-processo": _vm.existeNumeroDoProcesso,
      "numero-do-processo": _vm.numeroDoProcesso,
      "operacao-bancaria": _vm.operacaoBancaria,
      "operacao-bancaria-complementar": _vm.operacaoBancariaComplementar,
      "origem-da-assinatura": _vm.origemDaAssinatura,
      "status": _vm.status,
      "situacao-do-prazo-do-dossie": _vm.situacaoDoPrazoDoDossie
    },
    on: {
      "prorrogar": _vm.abrirModalDeProrrogacao
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade-de-cards"
  }, [_c('dados-do-proponente', {
    attrs: {
      "proponentes": _vm.proponentes,
      "renda-total": _vm.rendaTotal,
      "renda-total-comprovada": _vm.rendaTotalComprovada
    }
  }), _vm._v(" "), _c('dados-do-imovel', {
    attrs: {
      "construtora": _vm.construtora,
      "cidade": _vm.cidade,
      "empreendimento": _vm.empreendimento,
      "imovel": _vm.imovel,
      "valor-da-compra-e-venda": _vm.valorDaCompraEVenda,
      "participacao-do-solicitante": _vm.participacaoDoSolicitante,
      "valor-do-financiamento-aprovado": _vm.valorDoFinanciamentoAprovado,
      "subsidio-da-agehab": _vm.subsidioDaAgehab,
      "subsidio-do-governo-federal": _vm.subsidioDoGovernoFederal,
      "fgts-do-solicitante": _vm.fgtsDoSolicitante,
      "desconto-da-construtora": _vm.descontoDaConstrutora,
      "solicitacao-eh-do-bonus-moradia": _vm.solicitacaoEhDoBonusMoradia
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.abaSelecionada === 'linha-do-tempo') ? _c('div', {
    staticClass: "container_com-margem"
  }, [_c('linha-do-tempo', {
    attrs: {
      "itens": _vm.itensDaLinhaDoTempo,
      "tags-grandes": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.acaoEmAndamento) ? _c('dialogo-de-situacao', {
    attrs: {
      "situacao-atual": _vm.status,
      "acao": _vm.acaoEmAndamento,
      "carregando": _vm.loading.visivel
    },
    on: {
      "fechar": _vm.fecharDialogoDeSituacao,
      "confirmar": _vm.confirmarAcaoDaSituacao
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalDeConfirmacaoDePagamentoEstaVisivel) ? _c('modal-autorizar-pagamento', {
    attrs: {
      "carregando": _vm.loading.visivel
    },
    on: {
      "fechar": _vm.fecharModalDeConfirmacaoDePagamento,
      "confirmar": _vm.onConfirmarPagamento
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalDeAlteracaoDeNupEstaVisivel) ? _c('modal-alterar-nup', {
    attrs: {
      "carregando": _vm.loading.visivel,
      "projeto-exige-numero-do-processo": _vm.projetoExigeNumeroDoProcesso
    },
    on: {
      "fechar": _vm.fecharModalDeAlteracaoDeNup,
      "confirmar": _vm.onConfirmarAlteracaoDeNup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalDeProrrogacaoEstaVisivel) ? _c('modal-de-prorrogacao', {
    attrs: {
      "carregando": _vm.loading.visivel,
      "estado": _vm.situacaoDoPrazoDoDossie && _vm.situacaoDoPrazoDoDossie.estado,
      "prazo-do-dossie": _vm.prazoDoDossie
    },
    on: {
      "fechar": _vm.fecharModalDeProrrogacao,
      "confirmar": _vm.onConfirmarProrrogacao
    }
  }) : _vm._e(), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos print has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/imagens/logo-relatorio-retrato.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d452f2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/DetalhesDaSolicitacao.vue
// module id = 1103
// module chunks = 1